/** Nikura predictive card enhancement; native Horizon product-form handles cart operations. */
const toElement = (target) => target instanceof Element ? target : null;

document.addEventListener('change', (event) => {
  const select = toElement(event.target)?.closest('select[data-eq-search-variants]');
  if (!(select instanceof HTMLSelectElement)) return;
  const row = select.closest('[data-eq-predictive-product]');
  const option = select.selectedOptions[0];
  if (!row || !option) return;
  const input = row.querySelector('product-form-component input[name="id"]');
  if (input instanceof HTMLInputElement) input.value = option.value;
  const current = row.querySelector('[data-eq-search-current]');
  const compare = row.querySelector('[data-eq-search-compare]');
  const from = row.querySelector('[data-eq-search-from]');
  if (current) current.textContent = option.dataset.price || '';
  if (compare) {
    compare.textContent = option.dataset.comparePrice || '';
    compare.toggleAttribute('hidden', !option.dataset.comparePrice);
  }
  if (from) from.hidden = true;
});

// Matching live Leaf event name/payload; one delegated listener covers server-morphed suggestions.
document.addEventListener('click', (event) => {
  const link = toElement(event.target)?.closest('a[data-eq-search-suggestion]');
  if (!link) return;
  const searchTerm = link.textContent?.trim();
  if (!searchTerm) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'click_search_suggestion', search_term: searchTerm });
});
